import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

const ServiceCard = ({ icon, title, description }) => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <div 
      ref={ref} 
      className={`service-card ${inView ? 'animated' : ''}`}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 0.6s ease, transform 0.6s ease'
      }}
    >
      <div className="service-icon">
        <i className={`fas ${icon}`}></i>
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

const Services = () => {
  useEffect(() => {
    // Add hover effect for cards
    const cards = document.querySelectorAll('.service-card');
    
    cards.forEach(card => {
      card.addEventListener('mouseenter', function() {
        this.style.transform = 'translateY(-10px)';
        this.style.boxShadow = '0 10px 30px rgba(0, 255, 76, 0.3)';
      });
      
      card.addEventListener('mouseleave', function() {
        this.style.transform = 'translateY(0)';
        this.style.boxShadow = '0 10px 30px -15px rgba(0, 0, 0, 0.8)';
      });
    });
    
    // Cleanup
    return () => {
      cards.forEach(card => {
        card.removeEventListener('mouseenter', null);
        card.removeEventListener('mouseleave', null);
      });
    };
  }, []);

  const serviceData = [
    {
      icon: 'fa-shield-alt',
      title: 'Anti-Hile Bypass',
      description: 'Çeşitli anti-hile sistemlerini ve koruma mekanizmalarını aşma konusunda uzmanız. En zorlu güvenlik önlemlerini aşmak için tespit edilemeyen çözümler sunuyoruz.'
    },
    {
      icon: 'fa-code',
      title: 'Özel Çözümler',
      description: 'Özel bypass çözümleri ve araçları geliştiriyoruz. Her ürünümüz, belirli güvenlik sistemlerine özel olarak tasarlanmakta ve sürekli güncellenmektedir.'
    },
    {
      icon: 'fa-microchip',
      title: 'Kernel Çözümleri',
      description: 'Sistem korumalarını ve güvenlik önlemlerini en düşük seviyede bypass etmek için güçlü kernel-mode çözümler geliştiriyoruz.'
    },
    {
      icon: 'fa-bug',
      title: 'Tersine Mühendislik',
      description: 'Karmaşık sistemleri analiz ederek güvenlik açıklarını tespit ediyor ve oyun deneyiminizi geliştirmek için etkili çözümler sunuyoruz.'
    }
  ];

  return (
    <section id="expertise" className="services">
      <div className="container">
        <div className="section-header">
          <h2>Uzman <span className="accent">Hizmetlerimiz</span></h2>
          <p>Premium oyun geliştirme çözümlerimiz</p>
        </div>
        <div className="services-grid">
          {serviceData.map((service, index) => (
            <ServiceCard 
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services; 